import type { EventContentArg } from '@fullcalendar/core'
import { StatusRing } from '@/components/StatusRing'
import { timeOf } from '@/logic/dates'
import type { EntryProps } from './shared'

/**
 * How entries are drawn inside FullCalendar's grids. A task is outlined in its
 * category colour with a small ring, its time in the hour grid, and its title;
 * a preview is at half strength and dashed; a done row is struck through. An
 * event is filled with its owner's colour and has no ring, so the two never
 * rely on colour alone to be told apart.
 */
export function GridEntryContent({ arg }: { arg: EventContentArg }) {
  const p = arg.event.extendedProps as EntryProps
  const time = !arg.event.allDay && arg.event.start ? timeOf(arg.event.start) : ''
  if (p.kind === 'event') {
    return (
      <span className="fcx-ev" title={arg.event.title}>
        {time && <span className="fcx-ev__time">{time}</span>}
        <span className="fcx-ev__title">{arg.event.title}</span>
      </span>
    )
  }
  const { item, color } = p
  const state = item.done ? 'done' : item.task.waiting ? 'waiting' : 'open'
  const style = color ? ({ '--cat': color } as React.CSSProperties) : undefined
  return (
    <span className={`fcx-task ${item.faint ? 'fcx-task--faint' : ''} ${item.done ? 'fcx-task--done' : ''}`} style={style} title={arg.event.title}>
      <span className="fcx-task__time">
        <StatusRing state={state} color={color} label="" size="mini" inert />
        {time}
      </span>
      <span className="fcx-task__title">
        {(item.done || item.faint) && <span className="sr-only">{item.done ? 'Done: ' : 'Not yet: '}</span>}
        {arg.event.title}
      </span>
    </span>
  )
}
